<!-- 疗效跟踪详情 -->
<template>
  <div>
    <a-modal v-model:visible="visible" title="疗效跟踪" :footer="null" centered>
      <div class="title">疗效反馈结果</div>
      <div class="curativeContainer">
        <div class="curativeItem" v-for="(item, index) in CurativeTypes" :key="index + item.label">
          <auth-img class="iconImg" :src="calcSatusImg(item, index)" alt="" />
          <div class="label">{{ item.label }}</div>
        </div>
      </div>
      <div class="feedback">
        {{ CurativeTypes[activeIndex].activeMsg }}
      </div>
      <div class="txt">填写人：{{ handleCommitUser() }}</div>
      <div class="txt">填写时间： {{ commitInfo.commitTime }}</div>
    </a-modal>
  </div>
</template>
<script setup>
import { ref, defineExpose } from 'vue'
import { CurativeTypes } from '@/views/WorkPlace/Container/chat/components/message/config'
const visible = ref(false)

const calcSatusImg = ctx => {
  const activeVal = commitInfo.value.result ? Number(commitInfo.value.result) : -1
  return ctx.status === activeVal ? ctx.activeIcon : ctx.icon
}
const commitInfo = ref({})
const activeIndex = ref(0)
const initModal = data => {
  commitInfo.value = data
  visible.value = true
  const curartiveStatus = Number(data.result)
  if (curartiveStatus) {
    activeIndex.value = CurativeTypes.findIndex(item => item.status === curartiveStatus)
  } else {
    activeIndex.value = null
  }
}
defineExpose({
  initModal
})
const handleCommitUser = () => {
  const arr = ['系统', '患者', '医生', 'BD', '健管', '合作医院', 'cms', '医生学生']
  const role = arr[commitInfo.value.commitAccountType] || ''
  return role ? role + '-' + commitInfo.value.commitUserName : commitInfo.value.commitUserName
}
</script>
<style scoped lang="scss">
.title {
  font-size: 16px;
}
.curativeContainer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 20px 0;
  .curativeItem {
    text-align: center;
    .iconImg {
      width: 28px;
      height: 28px;
    }
    .label {
      margin-top: 20px;
    }
  }
}
.feedback {
  margin-bottom: 20px;
  font-weight: 400;
  font-size: 14px;
  color: #3b3b3b;
}
.txt {
  margin-bottom: 8px;
}
</style>
